export default {
  //----- GENERAL -----------------------------------------------------------------------

  PRODUCTION: false,
  API: "/api/",
  // API: "http://configurator.mgd.local/",
  API_FUNCTIONS: "functions.php",

  //----- USER -----------------------------------------------------------------------

  // user types
  TYPE_INDEX: ["User", "Admin", "Team"],
  TYPE: {
    USER: 0,
    ADMIN: 1,
    TEAM: 2,
  },

  //----- OBJECT MODELS --------------------------------------------------------------

  //USER OBJECT
  USER: {
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    zip: "",
    city: "",
    country: "Luxembourg",
    tel: "",
    userType: "user",
    active: true,
    createdOn: null,
    modifiedOn: null,
  },

  //CONFIGURATION OBJECT
  CONFIGURATION: {
    userId: "",
    status: "draft",
    confirmed: false,
    createdOn: null,
    modifiedOn: null,
    config: {
      activeCase: "daily",
      activeStrapType: "leather",
      activeStrap: "black",
      activeLeatherColor: "black",
      activeVarnishColor: "black",
      activeThreadNum: "180",
      leatherLocked: true,
      activeDialGroup: "stones",
      activeDialStone: "malachite",
      activeDialFinish: "polished",
      activeDialColor: "titanium",
      activeDial2: null,
      activeDial2Group: "stones",
      activeDial2Stone: "malachite",
      activeDial2Finish: "polished",
      activeDial2Color: "titanium",
      activePastille: null,
      activePastilleGroup: "stones",
      activePastilleStone: "malachite",
      activePastilleFinish: "polished",
      activePastilleColor: "titanium",
      activeRehautSeconde: null,
      activeRehautOuter: null,
      activeRehautOuterFinish: "polished",
      activeRehautInner: null,
      activeRehautInnerFinish: "polished",
      activeHandsStyle: "dauphine",
      activeHandsFinish: "brushed",
      activeSmallHandFinish: "brushed",
      activeLogoFinish: "brushed",
      activeRotor: "default",
      activeCaseback: "default",
    },
  },

  //----- COLLECTION REFERENCES -----------------------------------------------------------------------
  COLLECTION: {
    USERS: "users",
    CONFIGURATIONS: "configurations",
  },

  //----- UTILITIES ------------------------------------------------------------------

  // get a js Date from firestore timestamp
  getDateFromTimestamp: function (timestamp) {
    if (!timestamp) return null;
    return new Date(timestamp.seconds * 1000);
  },
  // get a js Date from milliseconds
  getDateStringFromMillis: function (millis) {
    if (!millis) return "-";
    let date = new Date(millis);
    // format: DD/MM/YYYYY
    return date.toLocaleDateString("fr-FR");
  },
  getTrimmedId(completeId, lenght) {
    if (!completeId) return "";
    return completeId.substring(0, lenght);
  },
  getTrimmedId12(completeId) {
    if (!completeId) return "";
    return completeId.substring(0, 12);
  },
  isInt: function (value) {
    return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
  },
  isArrayOfObjects(val) {
    return Array.isArray(val) && val.length > 0 && val.every((v) => v && typeof v === "object" && !Array.isArray(v));
  },
  isArrayOfPrimitives(val) {
    return Array.isArray(val) && val.length > 0 && val.every((v) => typeof v !== "object");
  },
  isStringArray(val) {
    return Array.isArray(val) && typeof val[0] === "string";
  },
  isObjectArray(val) {
    return Array.isArray(val) && typeof val[0] === "object" && val[0] !== null;
  },
};
